var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"mb-3 word-bold lh-fs"},[_vm._t("icon"),_vm._t("default"),_c('br'),_c('div',{staticClass:"spanfs ml-3"},[_vm._t("etext")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }